import { clearCheckoutSessionAfterPayment } from '@/services/funnel-cleanup.service';
import { getCheckoutSession, ordersService } from '@/services/orders.service';
import { useEffect, useRef } from 'react';

const POLL_INTERVAL_MS = 2000;
const MAX_POLL_ATTEMPTS = 10;

export function usePaymentSuccessCleanup(returnCase: string | null): void {
  const hasCleanedUpRef = useRef(false);

  useEffect(() => {
    if (returnCase !== 'success' || hasCleanedUpRef.current) return;

    const session = getCheckoutSession();
    if (!session) return;

    let attempts = 0;

    const pollAndCleanup = async () => {
      attempts += 1;
      try {
        const order = await ordersService.getCheckout(session.orderId, session.checkoutToken);
        if (order.status !== 'paid') {
          if (attempts < MAX_POLL_ATTEMPTS) {
            setTimeout(pollAndCleanup, POLL_INTERVAL_MS);
          }
          return;
        }

        hasCleanedUpRef.current = true;
        clearCheckoutSessionAfterPayment();
      } catch {
        if (attempts < MAX_POLL_ATTEMPTS) {
          setTimeout(pollAndCleanup, POLL_INTERVAL_MS);
        }
      }
    };

    void pollAndCleanup();
  }, [returnCase]);
}
